import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-dark bg-dark" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "/branding/logo.png",
  height: "60"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarColor02",
  "aria-controls": "navbarColor02",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarColor02"
}
const _hoisted_6 = { class: "navbar-nav" }
const _hoisted_7 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("ul", { class: "navbar-nav me-auto" }, null, -1)
const _hoisted_9 = { class: "navbar-nav" }
const _hoisted_10 = {
  key: 0,
  class: "nav-item dropdown"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "nav-link dropdown-toggle",
  "data-bs-toggle": "dropdown",
  role: "button",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, " Account ", -1)
const _hoisted_12 = { class: "dropdown-menu" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "dropdown-item",
  "data-bs-toggle": "modal",
  "data-bs-target": "#userSettingsModal"
}, " Settings ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_15 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_16 = {
  key: 0,
  class: "modal fade",
  id: "userSettingsModal",
  tabindex: "-1",
  "aria-labelledby": "userSettingsModalLabel",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_user_settings_modal = _resolveComponent("user-settings-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: { name: 'home' },
          class: "navbar-brand"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            (_ctx.adminOrEmp)
              ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                  _createVNode(_component_router_link, {
                    to: { name: 'exercises' },
                    class: "nav-link active"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Exercitii ")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_8,
          _createElementVNode("ul", _hoisted_9, [
            (_ctx.authenticated)
              ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _hoisted_14,
                    _createElementVNode("a", {
                      href: "#",
                      class: "dropdown-item",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logoutButton && _ctx.logoutButton(...args)), ["prevent"]))
                    }, " Logout ")
                  ])
                ]))
              : (_openBlock(), _createElementBlock("li", _hoisted_15, [
                  _createVNode(_component_router_link, {
                    to: { name: 'login' },
                    class: "nav-link active"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Login ")
                    ]),
                    _: 1
                  })
                ]))
          ])
        ])
      ])
    ]),
    (_ctx.authenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_user_settings_modal)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}